import { ICombinedUserData } from 'lib/context';

export const generateAudioFileName = (
  prefix: string | undefined,
  fileExt: string,
  userData: ICombinedUserData
) => {
  const randomSuffix = (Math.random() + 1).toString(36).substring(2);
  // Use 'audio' as default if prefix is null or undefined
  const effectivePrefix = prefix ?? 'audio';
  const fileName = `${effectivePrefix}_${userData.userId}_${userData.customerId}_${randomSuffix}.${fileExt}`;
  return fileName;
};
